
import api from '../utils/api';

class InviteApi {
  getAll = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api
          .get("/invites", { params: data });
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  getByOrderId = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api
          .get(`/invites/order/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };



  create = (data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api
          .post("/invites", data);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };

  update = (id, data) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api
            .patch(`/invites/${id}`, data);
        resolve(res.data);
    } catch (error) {
        reject(error);
    }
    });
  };

  delete = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api
            .delete(`/invites/${id}`);
        resolve(res.data);
    } catch (error) {
        reject(error);
    }
});
  };

  getDetail = (id) => {
    return new Promise(async (resolve, reject) => {
      try {
        const res = await api
          .get(`/invites/${id}`);
        resolve(res.data);
      } catch (error) {
        reject(error);
      }
    });
  };
}
const inviteApi = new InviteApi();
export default inviteApi;